import {AfterViewInit, Component, ElementRef, HostBinding, ViewChild} from '@angular/core';
import {I18nKeyEnum} from '../shared/models/language.model';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Country} from '../shared/models/countries.model';
import {combineLatest, Subscription, timeout} from 'rxjs';
import {CountryService} from '../shared/services/country.service';
import {ValidatorsErrorEnum} from '../shared/models/form.model';
import {ValidatorService} from '../shared/services/validator.service';
import {FreeTrialService} from '../shared/services/free-trial.service';
import {FreeTrialAccount} from '../shared/models/free-trial.model';
import {AccountService} from '../shared/services/account.service';
import {UserAccount} from '../shared/models/account.model';
import {IconEnum} from '../shared/models/assets.model';
import {CaptchaService} from '../shared/services/captcha.service';
import {CrawlerService} from '../shared/services/crawler.service';

@Component({
    selector: 'app-free-trial',
    standalone: false,
    templateUrl: './free-trial.component.html',
    styleUrl: './free-trial.component.scss'
})
export class FreeTrialComponent implements AfterViewInit {
    private MOCK_FREE_TRIAL = false; // TODO REMOVE
    private MOCK_FREE_TRIAL_DATA = false; // TODO REMOVE
    private subscriptions = new Subscription();
    private defaultAcc: string | undefined;
    private readonly defaultDomain = '@egroup-internal.io';
    protected readonly I18nKeyEnum = I18nKeyEnum;
    @HostBinding('class.free-trial') default = true;
    @HostBinding('class.hide') initializedSetupRequiredData = false;
    @ViewChild('captcha', {static: false}) public captchaElem: ElementRef | undefined;
    public userAccount: UserAccount | undefined;
    public firstNameCtrl = new FormControl();
    public captchaCtrl = new FormControl<string | undefined>(undefined, Validators.required);
    public emailCtrl = new FormControl();
    public websiteCtrl = new FormControl();
    public nationalNumberCtrl = new FormControl();
    public countryPrefixCtrl = new FormControl();
    public readonly validatorsErrorEnum = ValidatorsErrorEnum;
    public countries: Country[] = [];
    public ICONS = IconEnum;
    public websiteForm = new FormGroup({
        website: this.websiteCtrl,
        captcha: this.captchaCtrl
    });
    public freeTrialForm = new FormGroup({
        countryPrefix: this.countryPrefixCtrl,
        nationalNumber: this.nationalNumberCtrl,
        firstName: this.firstNameCtrl
    });
    public crawlingInitialized = false;

    constructor(private readonly countryService: CountryService,
                private readonly freeTrialService: FreeTrialService,
                private readonly validatorService: ValidatorService,
                private readonly accountService: AccountService,
                private readonly captchaService: CaptchaService,
                private readonly crawlerService: CrawlerService) {

        this.initSubscriptions();
        this.defaultAcc = this.accountService.generateAccountName();
        if (this.MOCK_FREE_TRIAL_DATA) {
            setTimeout(() => {
                this.mockFreeTrialData();
            }, 1000);
        }
       


        combineLatest([
            this.countryService.preSelectedCountry$,
            this.countryService.countries$]).subscribe(data => {
            this.countryPrefixCtrl.setValue(data[0]);
            this.countries = data[1];
            this.countryPrefixCtrl.setValue(this.countries[0]);
        });
    }

    validatePhoneNumber() {
        if (!!this.countryPrefixCtrl.value?.countryPrefix && (!!this.nationalNumberCtrl.value && this.nationalNumberCtrl.value.length > 0)) {
            if (this.validatorService.checkValidNumber(this.countryPrefixCtrl.value.countryPrefix, this.nationalNumberCtrl.value)) {
                this.nationalNumberCtrl.setErrors(null);
                const formattedNumber = this.validatorService.getNationalNumber(this.countryPrefixCtrl.value.countryPrefix, this.nationalNumberCtrl.value);
                if (!!formattedNumber && this.nationalNumberCtrl.value !== formattedNumber) {
                    this.nationalNumberCtrl.setValue(formattedNumber);
                }
            } else {
                this.nationalNumberCtrl.setErrors({[this.validatorsErrorEnum.INVALID_NUMBER]: true});
            }
        }
    }

    initAccount() {
        this.freeTrialForm.markAllAsTouched();
        this.freeTrialForm.updateValueAndValidity();
        if (this.MOCK_FREE_TRIAL) {
            this.freeTrialService.mockRegisterWithoutData();
            return;
        }

        if (!this.freeTrialForm.valid || !this.websiteCtrl?.value || !this.defaultAcc) {
            return;
        }
        const data = this.freeTrialForm.value;
        const captcha = this.captchaCtrl?.value ? this.captchaCtrl.value : '';
        const newAccount = new FreeTrialAccount(this.defaultAcc, this.defaultDomain, data.countryPrefix.countryPrefix,
            data.nationalNumber, this.websiteCtrl?.value, captcha);
        console.log('DEBUG: ------', newAccount);
        this.freeTrialService.registerFreeTrialAccount(newAccount, data.firstName);
    }

    ngAfterViewInit(): void {
        if (!this.captchaElem) {
            return;
        }
        this.captchaService.initCaptcha(this.websiteForm, this.captchaElem, 'captcha');
    }

    initCrawling() {
        this.websiteForm.markAllAsTouched();
        this.websiteForm.updateValueAndValidity();
        if (this.websiteForm.invalid || !this.websiteCtrl.value || !this.defaultAcc) {
            return;
        }
        this.crawlerService.initCrawler(this.websiteCtrl.value, this.defaultAcc.concat(this.defaultDomain));
        this.crawlingInitialized = true;
    }

    private initSubscriptions() {
        this.subscriptions.add(this.accountService.userAccount$.subscribe((userAccount) => {
            this.userAccount = userAccount;
        }));
        this.subscriptions.add(this.freeTrialService.freeTrialInitialized$.subscribe((initialized) => {
            this.initializedSetupRequiredData = initialized;
        }));

    }
    
    private mockFreeTrialData() {
        this.firstNameCtrl.setValue('ADD_EMAIL');
        this.emailCtrl.setValue('Maier');
        this.websiteCtrl.setValue('https://www.berlin-flamingos.de/');
        this.nationalNumberCtrl.setValue('17647749985');
    }
}
